import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Layout } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import HeaderNav from '../../components/HeaderNav';
import Aside from '../../components/Aside';
import Loader from '../../components/Loader';
import Clock from 'react-live-clock';
import './index.css';
import get_branch_name from "./weather_branch_list";

const { Sider } = Layout;

class ContentLayout extends Component {
  constructor(props) {
    super(props);
    const isMobile = typeof window !== 'undefined' ? window.innerWidth <= 768 : false;
    this.state = {
      collapsed: isMobile,
      isMobile,
      mobileDrawerOpen: false,
      temp: null,
      icon: null,
      rawIcon: null,
    };
  }

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  closeMobileDrawer = () => {
    this.setState({ mobileDrawerOpen: false });
  };

  toggleMobileDrawer = () => {
    this.setState((prevState) => ({ mobileDrawerOpen: !prevState.mobileDrawerOpen }));
  };

  handleResize = () => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ 
        isMobile, 
        collapsed: isMobile,
        mobileDrawerOpen: false,
      });
    }
  };

  handleKeyDown = (e) => {
    if (e.key === 'Escape' && this.state.mobileDrawerOpen) {
      this.closeMobileDrawer();
    }
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleKeyDown);
    this.fetchWeather();
  }

  componentDidUpdate(prevProps) {
    // Automatically close mobile drawer when navigating to a new page
    if (this.props.location?.pathname !== prevProps.location?.pathname && this.state.mobileDrawerOpen) {
      this.closeMobileDrawer();
    }

    const prevBranchId = prevProps.userData?.profile?.branch?.id;
    const currentBranchId = this.props.userData?.profile?.branch?.id;
    if (currentBranchId && (currentBranchId !== prevBranchId || !this.state.temp)) {
      this.fetchWeather();
    }
  }

  fetchWeather = () => {
    const { userData } = this.props;
    let id = userData?.profile?.branch?.id;
    const branchQuery = get_branch_name(id);
    const cacheKey = `weather_${branchQuery || 'default'}`;

    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const { data, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < 20 * 60 * 1000) {
          this.setState({
            temp: data.temp,
            icon: data.icon,
            rawIcon: data.rawIcon,
          });
          return;
        }
      }
    } catch (e) {}

    axios({
      method: 'get',
      url: 'https://api.openweathermap.org/data/2.5/weather',
      params: {
        q: branchQuery,
        appid: '6932037609306160a119e62e7882bc3e',
        units: 'metric',
        lang: 'ru',
      },
    })
      .then((response) => {
        let icon = '01-s';
        const rawIcon = response?.data?.weather[0]?.icon || '01d';
        switch (rawIcon) {
          case '01d':
            icon = '01-s';
            break;
          case '01n':
            icon = '33-s';
            break;
          case '02d':
            icon = '04-s';
            break;
          case '02n':
            icon = '36-s';
            break;
          case '03d':
          case '03n':
            icon = '07-s';
            break;
          case '04d':
          case '04n':
            icon = '08-s';
            break;
          case '09d':
          case '09n':
            icon = '12-s';
            break;
          case '10d':
            icon = '14-s';
            break;
          case '10n':
            icon = '39-s';
            break;
          case '11d':
          case '11n':
            icon = '15-s';
            break;
          case '13d':
          case '13n':
            icon = '22-s';
            break;
          case '50d':
          case '50n':
            icon = '11-s';
            break;
          default:
            icon = '01-s';
        }
        const temp = Math.round(response?.data?.main?.temp);
        try {
          sessionStorage.setItem(
            cacheKey,
            JSON.stringify({ data: { temp, icon, rawIcon }, timestamp: Date.now() })
          );
        } catch (e) {}
        this.setState({
          temp,
          icon,
          rawIcon,
        });
      })
      .catch((error) => {
        console.error('Weather fetch error:', error);
      });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  render() {
    const { collapsed, isMobile, mobileDrawerOpen, temp, icon, rawIcon } = this.state;
    const { isAuthenticated, isLoading, userData } = this.props;

    let timezon = 'Asia/Almaty';
    if (userData?.profile?.branch?.timezon === 1) {
      timezon = 'Asia/Oral';
    } else if (userData?.profile?.branch?.timezon === 2) {
      timezon = 'Asia/Almaty';
    }
    const branchName = userData?.profile?.branch?.name || '';

    if (!isAuthenticated)
      return (
        <>
          {isLoading && <Loader />}
          {this.props.children}
        </>
      );

    return (
      <>
        {isLoading && <Loader />}

        {/* Custom Mobile Sidebar Overlay Drawer */}
        {isMobile && (
          <div
            className={`custom-mobile-drawer ${mobileDrawerOpen ? 'drawer-open' : ''}`}
            aria-hidden={!mobileDrawerOpen}
          >
            {/* Backdrop Mask */}
            <div
              className='custom-mobile-drawer-mask'
              onClick={this.closeMobileDrawer}
            />

            {/* Slide-out Sidebar Content */}
            <div className='custom-mobile-drawer-content'>
              <div className='custom-mobile-drawer-header'>
                <div className='logo mobile-drawer-logo' />
                <button
                  type='button'
                  className='custom-mobile-drawer-close-btn'
                  onClick={this.closeMobileDrawer}
                  aria-label='Закрыть меню'
                >
                  <CloseOutlined style={{ fontSize: 18, color: '#ffffff' }} />
                </button>
              </div>

              {/* Weather, Branch Time & City Bar */}
              <div className='mobile-drawer-info-card'>
                {temp != null && !isNaN(temp) && (
                  <div className='drawer-weather-item'>
                    <img
                      className='drawer-weather-icon'
                      src={`https://openweathermap.org/img/wn/${rawIcon || '01d'}.png`}
                      alt='weather'
                    />
                    <span className='drawer-weather-temp'>{`${temp}°`}</span>
                  </div>
                )}
                <div className='drawer-time-item'>
                  <Clock
                    className='drawer-live-clock'
                    format={'HH:mm'}
                    ticking={true}
                    timezone={timezon}
                  />
                </div>
                {branchName && (
                  <div className='drawer-branch-item'>
                    <span className='drawer-branch-dot'>•</span>
                    <span className='drawer-branch-name'>{branchName}</span>
                  </div>
                )}
              </div>

              <div className='custom-mobile-drawer-body'>
                <Aside
                  userData={userData}
                  collapsed={false}
                  onItemClick={this.closeMobileDrawer}
                />
              </div>
            </div>
          </div>
        )}

        <Layout style={{ height: '100vh', width: '100vw', maxWidth: '100%', overflow: 'hidden' }}>
          {/* Desktop Sider */}
          {!isMobile && (
            <Sider
              width={250}
              trigger={null}
              collapsible
              collapsed={this.state.collapsed}
            >
              <div className='logo' />
              <Aside
                userData={userData}
                collapsed={this.state.collapsed}
              />
            </Sider>
          )}

          <div className='app-main-layout'>
            <HeaderNav
              temperature={temp}
              icon={{ icon, rawIcon }}
              collapsed={isMobile ? !mobileDrawerOpen : collapsed}
              onCollapse={(value) => {
                if (isMobile) {
                  this.toggleMobileDrawer();
                } else {
                  this.onCollapse(value);
                }
              }}
              userData={userData}
            />

            <main className='app-main-content'>
              {this.props.children}
            </main>
          </div>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.loader.loading,
    userData: state.user.userData,
  };
};

export default withRouter(connect(mapStateToProps)(ContentLayout));
